import React from 'react'
import cn from 'classnames'
import st from './index.scss'
import '@/public/js/iconfont'
/**
 * 2022-10-29
 * @param {name} 需要引入的class名称
 * @returns
 */
export default function Icon({ name, className, ...props }) {
    return (
        <svg
            className={cn(st['icon'], className)}
            aria-hidden={true}
            {...props}
        >
            <use xlinkHref={`#icon-${name}`}></use>
        </svg>
    )
}
